import { restApi } from '../../api';
import { RachelFileOutput } from './rachelFiles.types';

const PATH = 'rachel/files';

export const uploadRachelFile = (file: File, signal?: AbortSignal) => {
  const formData = new FormData();
  formData.append('file', file, file.name);

  return restApi.post<RachelFileOutput>(PATH, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    signal,
  });
};
